<template>
  <div>
    <PageTitle
      title="Order Payment View"
      :backBtn="true"
      :servicecharge="true"
      :permission="'Purchase Order Edit'"
      @onClickSericeCharge="addserviceCharge"
    />
    <v-container fluid class="lighten-12 container">
      <!-- Page Title -->

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="3">
          <v-card class="lighten-12">
            <v-card-title>Guest order</v-card-title>
            <v-container fluid>
              <v-row> </v-row>
              <v-row>
                <v-col cols="7" xs="6" sm="6" md="6" lg="6">
                  <h4>Reference number</h4></v-col
                >
                <v-col cols="5" xs="6" sm="6" md="6" lg="6"
                  ><v-chip label>
                    {{
                      billDetails.order_number
                        ? billDetails.order_number
                        : "----"
                    }}
                  </v-chip></v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" sm="6" md="6" lg="6"> <h4>Date</h4></v-col>
                <v-col cols="5" sm="6" md="6" lg="6"
                  ><v-chip label>
                    {{ billDetails.date ? billDetails.date : "----"|formatDate  }}
                  </v-chip></v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" sm="6" md="6" lg="6"> <h4>Status</h4></v-col>
                <v-col cols="5" sm="6" md="6" lg="6">
                  <v-chip
                    label
                    text-color="white"
                    :color="getPurchaseOrderStatusColor(billDetails.status)"
                    dark
                    >{{
                     getPurchaseOrderStatuslable(billDetails.status)
                    }}</v-chip
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" sm="6" md="6" lg="6">
                  <h4>Order Type</h4></v-col
                >
                <v-col cols="5" sm="6" md="6" lg="6"
                  ><v-chip label>
                    {{
                       getPurchaseOrderordertype( billDetails.order_type)
                     
                    }}
                  </v-chip></v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" sm="6" md="6" lg="6"> <h4>     {{ billDetails.guest.id ? "Customer" : "Staff" }}</h4></v-col>
                <v-col cols="5" sm="6" md="6" lg="6"
                  ><v-chip label>
                    {{ billDetails.guest.id ? billDetails.guest.name : billDetails.staff.name }}
                  </v-chip></v-col
                >
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-card class="lighten-12">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <v-card-title>Payments</v-card-title>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <v-card-title
                  >Outstanding payment:-
                  {{
                    (billDetails.net_amount - billDetails.paid_amount)
                      | formatCurrency
                  }}</v-card-title
                >
              </v-col>
            </v-row>

            <v-container class="ma-0 pa-0">
              <v-row class="ma-2 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-expansion-panels class="ma-1 pa-0">
                    <v-expansion-panel class="ma-1 pa-0">
                      <v-expansion-panel-header class="expansion">
                        <v-row class="text-left ma-0 pa-0 mt-2">
                          <v-col
                            cols="2"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 lablefont"
                          >
                            Total Amount
                          </v-col>
                          <v-col
                            cols="2"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 "
                          >
                            <v-chip label>{{
                              billDetails.amount | formatCurrency
                            }}</v-chip>
                          </v-col>

                          <v-col cols="12" sm="12" md="1" lg="1" xl="1">
                           <v-icon medium color="green darken-2">mdi-plus-thick</v-icon> 
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 lablefont"
                          >
                            Service Charge
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 "
                          >
                            <v-chip label>{{
                              billDetails.service_charge | formatCurrency
                            }}</v-chip></v-col
                          >

                          <v-col cols="12" sm="12"  md="1" lg="1" xl="1">
                           <v-icon medium color="red lighten-2">mdi-window-minimize</v-icon> 
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 lablefont"
                          >
                            Discount Amount
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1"
                          >
                            <v-chip label>{{
                              billDetails.descount | formatCurrency
                            }}</v-chip>
                          </v-col>

                          <v-col cols="12" sm="12" md="1" lg="1" xl="1" small>
                            <v-icon medium>mdi-view-agenda</v-icon>
                            <!-- <v-chip color="green"> = </v-chip> -->
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="1"
                            xl="1"
                            class="Ui1 lablefont"
                          >
                            Net Amount
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="2"
                            lg="2"
                            xl="2"
                            class="Ui1"
                          >
                            <v-chip label>{{
                              billDetails.net_amount | formatCurrency
                            }}</v-chip></v-col
                          >

                          <v-col
                            cols="12"
                            sm="12"
                            md="1"
                            lg="1"
                            class="Ui1 pl-3 ma-0 pa-2"
                            v-if="
                              billDetails.net_amount - billDetails.paid_amount >
                                0
                            "
                          >
                            <v-btn
                              rounded
                              color="primary"
                              dark
                              @click="OpenPayment()"
                              class="mt-0"
                              >PAY</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="ma-0 pa-0">
                        <v-data-table
                          :headers="PaymentHeaders"
                          :items="billDetails.payments"
                          hide-default-footer
                          disable-pagination
                          dense
                        >
                          <template
                            v-slot:item.status="{ item }"
                            v-slot="{ errors }"
                            name="Quantity"
                            rules="numeric"
                          >
                            <v-chip
                              :x-small="true"
                              class="ma-2"
                              label
                              text-color="white"
                              :color="getOrderStatusColor(item.status)"
                              dark
                              >{{ item.status }}</v-chip
                            >
                          </template>

                          <template v-slot:item.action="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-if="
                                    !(
                                      item.status != 'Pending' &&
                                      item.payment_type == 'Cheque'
                                    )
                                  "
                                  small
                                  class="mr-2"
                                  @click.stop="OrderType(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>Edit Amount</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>

              <AddSuspendBillModal
                ref="PaymentModal"
                :payment="payment"
                :suspendId="this.$route.params.id"
                @conform="refreshPayments"
              />

              <!-- <AdditionalAmountModel
                ref="AdditionalAmount"
                :additional-amount="additionalAmount"
                @conform="refreshPayments"
                :purchaseId="purchaseId"
            /> -->
              <OrderTypeModel
                ref="PaymentEditModel"
                :suspendId="this.$route.params.id"
                :payment="payment"
                @conform="refreshPayments"
              />
            </v-container>
          </v-card>
          <!-- <v-card class="lighten-12">
            <v-card-title class="d-flex justify-space-between"
              >payments
              <v-btn
                small
                class="text-white btn_gray w-100 d-none d-sm-flex"
                v-print="printQr"
                >Print <v-icon right dark> mdi-printer </v-icon></v-btn
              ></v-card-title
            >
            <v-container fluid>
             
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="PaymentHeaders"
                    :items="billDetails.payments"
                    hide-default-footer
                    disable-pagination
                    dense
                  >

                  
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card>
            <v-card-title>Order Items</v-card-title>

            <v-container fluid>
                 {{ totalfoodamount | formatCurrency }}
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12"
                  >
                  <v-data-table
                    
                   items-per-page="1000"
                :fixed-header="true"
                :headers="foodorderheader"
                :items="billDetails.items"
                item-key="id"
                  >
                   <template v-slot:item.dish="{ item }">
                     {{item.dish.name}}
                    
                </template>
                <template v-slot:item.unit="{ item }">
                     {{item.unit.name}}
                    
                </template>
                 <template v-slot:item.amount="{ item }">
                   {{item.amount}}
                    
                </template>
                <template v-slot:item.amount="{ item }">
                   {{item.amount * item.quantity}}.00
                    
                </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card>
            <v-card-title>Note</v-card-title>

            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12"
                  ><v-chip class="pa-0" label>
                    {{ PurchaseOrder.remarks ? PurchaseOrder.remarks : "----" }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

        
      <ServiceCharge
        :visible="serviceChargevisible"
        @close="onCloseServiceCharge"
        :serviceCharge="servicechargeAmount"
        @AddingserviceCharge="addservicechargePayments"
      />
    </v-container>
  </div>
</template>

<script>
import ServiceCharge from "../../components/shared/ServiceCharge";
import FileUpload from "@/components/base/FileUpload";
import VueDocPreview from "vue-doc-preview";
import AddSuspendBillModal from "../shared/modals/AddSuspendBillModal";
import { Payment } from "../../models/Payment";
import OrderTypeModel from "../shared/modals/EditSuspendBillModel";

import "jspdf-autotable";
export default {
  data: () => ({
    totalfoodamount:0,
    payment: [],
    PurchaseOrder: [],
    billDetails: null,
    serviceChargevisible: false,
    servicechargeAmount: { amount: 0 },
    heading: "Sample PDF Generator",
    moreText: [
      "This is another few sentences of text to look at it.",
      "Just testing the paragraphs to see how they format.",
      "jsPDF likes arrays for sentences.",
      "Do paragraphs wrap properly?",
      "Yes, they do!",
      "What does it look like?",
      "Not bad at all."
    ],

    selectedProductsItems: [],
    PaymentHeaders: [
      { text: "Reference Number", value: "reference_number", sortable: false },
      { text: "Date", value: "date_time", sortable: false },
      { text: "payment Type", value: "payment_type", sortable: false },
      { text: "Amount", value: "amount", sortable: false, align: "center" },
      { text: "status", value: "status", align: "center" },
      { text: "", value: "action" }
    ],
    foodorderheader:[
       { text: "Ticket Number", value: "ticket_number", sortable: false },
        { text: "Dish", value: "dish", sortable: false },
         { text: "Unit", value: "unit", sortable: false },
          { text: "Quantity", value: "quantity", sortable: false },
          { text: "Amount", value: "amount", sortable: false },
    ]
  }),
  methods: {
    // add Service Charge Payments
    addservicechargePayments(event) {
      let credential = event;
      credential.Id = this.$route.params.id;
      this.$store
        .dispatch("dish/addserviceCharge", credential)
        .then(res => {
          this.$toast.success("Service Charge updated successfully");
          this.serviceChargevisible = false;
          this.GetBillDetails();
          this.servicechargeAmount.amount = 0;
        })
        .catch(err => {
          this.$toast.error("Service Charge updated failed");
          this.serviceChargevisible = false;
        });
    },
     sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    //close Popup service Charge
    onCloseServiceCharge() {
      this.serviceChargevisible = false;
    },
    //adding Service Charge open popup
    addserviceCharge(value) {
      this.serviceChargevisible = true;
    },
    OrderType(item) {
      //this.payment.account_id = this.Purchase.account_id;
      this.payment = _.cloneDeep(item);
      if (this.payment.cheque) {
        this.payment.cheque_bank = item.cheque.cheque_bank;
        this.payment.cheque_date = item.cheque.cheque_date;
        this.payment.cheque_no = item.cheque.cheque_no;
        this.payment.cheque_type = item.cheque.cheque_type;
      }

      this.$refs.PaymentEditModel.openModal();
    },
    OpenPayment() {
      this.payment = new Payment();
      this.$refs.PaymentModal.openModal();
    },
    getPurchaseOrderordertype(status){
       switch (status) {
        case "dine_in":
          return "Dine In";
          break;
        case "take_away":
          return "Take Away";
          break;
           case "service_order":
          return "Service Order";
        default:
          break;
      }
    },
    getPurchaseOrderStatuslable(status){
       switch (status) {
        case "paid":
          return "paid";
          break;
        case "partially_paid":
          return "Partially Paid";
          break;
        case "cancelled":
          return "Cancelled";
          break;
             case "pending":
          return "Pending";
          break;
               case "receiving":
          return "Receiving";
          break;
            case "completed":
          return "Completed";
          break;
        default:
          break;
      }
    },
    getOrderStatusColor(status) {
      switch (status) {
        case "Completed":
          return "green";
          break;
        case "Pending":
          return "orange";
          break;
        case "Canceled":
          return "red";
          break;
        default:
          break;
      }
    },
     getPurchaseOrderStatusColor(status) {
      
      switch (status) {
        case "paid":
          return "green";
          break;
        case "partially_paid":
          return "orange";
          break;
        case "cancelled":
          return "red";
          break;
            case "pending":
          return "yellow";
          break;
               case "receiving":
          return "Receiving";
          break;
            case "completed":
          return "Completed";
          break;
        default:
          break;
      }
    },
    print() {
      this.$htmlToPaper("qr-code");
    },
    GetBillDetails() {
      let Id = this.$route.params.id;
      this.$store

        .dispatch("dish/GetSingleOrder", Id)
        .then(res => {
         
          this.billDetails = res.data;
          this.servicechargeAmount.amount = res.data.service_charge;
           this.totalfoodamount = this.sumField(this.billDetails, "amount");
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    refreshPayments() {
      this.GetBillDetails();
    },
    async getOrganization() {
      await this.$store
        .dispatch("sitesetting/OrganizationView", 1)
        .then(res => {
          if (res && res.data) {
            this.PurchaseOrder.organization = res.data;
            console.clear();
            console.log(res.data);
          }
        })
        .catch(err => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    }
  },
  created() {
    this.GetBillDetails();
  },
  components: {
    FileUpload,
    VueDocPreview,
    AddSuspendBillModal,
    OrderTypeModel,
    ServiceCharge
  },
  computed: {}
};
</script>

<style scoped>
.expansion {
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 65px 24px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

.lablefont{
      font-family: fantasy;
    font-style: revert;
}
</style>
